export default __webpack_public_path__ + "static/media/exercise-red.7a20e776.svg";